import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { heroImage } from '../../data/presellContent';
export function Hero() {
  return <section id="hero" className="w-full bg-white" data-id="element-31" data-mp="323tn8rtqth5d">
      <div className="max-w-5xl mx-auto px-5 md:px-8 pt-12 md:pt-16 pb-14 md:pb-20" data-id="element-32" data-mp="324l5z228rke8">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="max-w-3xl" data-id="element-33" data-mp="2x3p56xd6sed1">
          <span className="inline-block bg-[#EAF1EE] text-[#3F6B62] px-4 py-1.5 rounded-full text-xs md:text-sm font-semibold tracking-[0.12em]" data-id="element-34" data-mp="364ncboix91zu">
            NEW JOINT DISCOVERY
          </span>

          <h1 className="mt-6 text-[2rem] leading-[1.15] md:text-5xl md:leading-[1.1] font-bold text-[#22322C]" data-id="element-35" data-mp="3fwjat0ox6u4l">
            What many people know as "wear and tear" in the hips, knees, elbows,
            and other joints could actually be{' '}
            <span className="text-[#3F8C86]" data-id="element-36" data-mp="22s6my4g49xeo">something else</span>.
          </h1>
        </motion.div>

        <motion.figure initial={{
        opacity: 0,
        scale: 0.98
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-9 md:mt-10" data-id="element-37" data-mp="26ts80d2t1hzy">
          <img src={heroImage} alt="Older adults doing farm work in a rural Japanese community" className="w-full h-[240px] sm:h-[320px] md:h-[420px] object-cover rounded-2xl" loading="eager" data-id="element-38" data-mp="2gszhuqabyuib" />
          <figcaption className="mt-3 text-sm text-[#8A9A8F]" data-id="element-39" data-mp="2pq9yys9txdv5">
            A remote farming community in the mountains of Japan, early morning.
          </figcaption>
        </motion.figure>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.15,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 max-w-2xl" data-id="element-40" data-mp="2zka8r7g237a7">
          <p className="text-lg md:text-xl text-[#4A5D50] leading-relaxed" data-id="element-41" data-mp="2jryfwm5cp0rx">
            New findings suggest that joint discomfort may not always be just
            about aging or wear. In many cases, the real issue may also involve
            the loss of the natural lubrication that helps joints move smoothly.
          </p>

          <div className="mt-9" data-id="element-42" data-mp="2oqsvzgbxob8c">
            <CtaButton size="large" data-id="element-43" data-mp="2opq538em28sf" />
          </div>
        </motion.div>
      </div>
    </section>;
}